GrouponValidate = require "../../../../../groupon/frontend/validate"
Backbone = require 'backbone'
Backbone.$ = $
SupportUserIdentificationTemplate = require '../../../../user_identification.html.mustache'

class EmailFormUSUserIdentificationView extends Backbone.View
  className: 'requestedFields'
  tagName: 'li'

  events:
    'keyup #tcktUsername': 'checkUserId'
    'keyup #tcktUsermail': 'checkMailId'

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @model = @options.model
    @isInputCompulsory = @model.required
    @template = SupportUserIdentificationTemplate

  getUsernameElement: ->
    @$el.find('#tcktUsername')

  getEmailIdElement: ->
    @$el.find('#tcktUsermail')

  checkUserId: ->
    @enableDisableSubmitButton()

  checkMailId: ->
    @enableDisableSubmitButton()
    email_id = @getEmailIdElement().val().trim()
    if GrouponValidate.email(email_id)
      $('#validateUserContactEmail').css('display','none')

  enableDisableSubmitButton: ->
    @options.validateEmailForm.call()

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)

  toHash:->
    isLoggedIn: currentUser?
    is_email: currentUser?.email?

  populateInput: (data) ->
    data.user_name = @getUsernameElement()?.val()?.trim()
    data.user_email = @getEmailIdElement()?.val()?.trim()
    data.userIdenficiationView = true

  validateEmailId: ->
    email_id = @getEmailIdElement()?.val()?.trim()
    if GrouponValidate.email(email_id)
      $('#validateUserContactEmail').css('display','none')
      return true
    else
      $('#validateUserContactEmail').css('display','block')
      return false

  isInputValid: ->
    @validateEmailId()

  isInputGiven: ->
    isvalid = true
    if @getUsernameElement()?.length > 0
      isvalid = @getUsernameElement()?.val()?.trim().length > 0
    if isvalid && @getEmailIdElement()?.length > 0
      isvalid = isvalid && @getEmailIdElement()?.val()?.trim().length > 0
    return isvalid


  close: ->
    #nothing to close for now

module.exports = EmailFormUSUserIdentificationView
